export default function waitingList(context) {
  context.instance.__markAsClean(context);
}